module.exports = __webpack_public_path__ + "media/thieme/Radiology-Flashcards_1024x1536px_2-aeaf7950.jpg";